
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32","height":"32","preserveAspectRatio":"xMidYMid meet"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#003653","fill-rule":"evenodd","d":"M23 27a2 2 0 01-2 2H11a2 2 0 01-2-2V5a2 2 0 012-2h10a2 2 0 012 2v22zm-1-7H10v7a1 1 0 00.883.993L11 28h10a1 1 0 00.993-.883L22 27v-7zm-9.5 2a.5.5 0 01.5.5v3a.5.5 0 11-1 0v-3a.5.5 0 01.5-.5zM21 4H11a1 1 0 00-.993.883L10 5v14h12V5a1 1 0 00-.883-.993L21 4zm-8.5 6a.5.5 0 01.5.5v6a.5.5 0 11-1 0v-6a.5.5 0 01.5-.5z"}})])
          )
        }
      }
    